import { render, staticRenderFns } from "./TabAuthorizeHeader.vue?vue&type=template&id=1a459358"
import script from "./TabAuthorizeHeader.vue?vue&type=script&lang=js"
export * from "./TabAuthorizeHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports